export default function CarrotButton({ onClick, text }) {
    return (
        <button className={'CarrotButton'} onClick={onClick}><span
            className="carrot">&gt;</span> {text}</button>
    );
}
